'use strict';

export { default } from './metadata.factory';